// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalCardFinderPatientRequest } from './medicalCardFinderPatientRequest.js';
import type { MedicalCardFinderPrescriberRequest } from './medicalCardFinderPrescriberRequest.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalCardFinderInputRequest {
    'patient': MedicalCardFinderPatientRequest | null;
    'prescriber': MedicalCardFinderPrescriberRequest | null;
    'project'?: string;
    'ndc'?: string;
    'clientWhiteListId'?: string;
    'clientId1'?: string;
    'clientId2'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalCardFinderInputRequest>> = [
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "MedicalCardFinderPatientRequest"
        },
        {
            "name":     "prescriber",
            "baseName": "prescriber",
            "type":     "MedicalCardFinderPrescriberRequest"
        },
        {
            "name":     "project",
            "baseName": "project",
            "type":     "string"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "clientWhiteListId",
            "baseName": "clientWhiteListId",
            "type":     "string"
        },
        {
            "name":     "clientId1",
            "baseName": "clientId1",
            "type":     "string"
        },
        {
            "name":     "clientId2",
            "baseName": "clientId2",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalCardFinderInputRequest.attributeTypeMap;
    }
}
